import { render, staticRenderFns } from "./PortalTermsAndConditions.vue?vue&type=template&id=9479e510"
import script from "./PortalTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./PortalTermsAndConditions.vue?vue&type=script&lang=js"
import style0 from "./PortalTermsAndConditions.vue?vue&type=style&index=0&id=9479e510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports